import { AtaChapterService } from "@common/client"
import { makeNoArgsQuery } from "./utils"

export const ataChaptersQuery = makeNoArgsQuery({
  serviceCall: AtaChapterService.listChapters,
  queryKey: ["ata-chapters"],
})
